// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QWvY","content":"styles_content__3n2l4","row":"styles_row__34qvv","footer":"styles_footer__1y4kK","phraseLength":"styles_phraseLength__sm8CU"};